import { useEffect, useState } from "react";
import { z } from "zod";
import { apiRequest } from "../../shared/api/client";

export type RecipeNode = { code: string; name: string; children: RecipeNode[]; cycle: boolean; incomplete: boolean;
  quantity: number | null; unit: string | null; parentQuantity: number | null; parentUnit: string | null };
const nodeSchema: z.ZodType<RecipeNode> = z.lazy(() => z.object({
  code: z.string(), name: z.string(), children: z.array(nodeSchema), cycle: z.boolean(), incomplete: z.boolean(),
  quantity: z.number().positive().nullable(), unit: z.string().min(1).nullable(),
  parentQuantity: z.number().positive().nullable(), parentUnit: z.string().min(1).nullable(),
}));
const recipeSchema = z.object({ source: z.literal("MICRO_ERP"), observedAt: z.iso.datetime(), root: nodeSchema, truncated: z.boolean(), edgeCount: z.number() });

export function useWeek39Recipe(code: string, weekStart?: string) {
  const [recipe, setRecipe] = useState<z.infer<typeof recipeSchema> | null>(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true); setError(""); setRecipe(null);
    void apiRequest<unknown>(`/api/sarf39/manual-packaging/recipe/${encodeURIComponent(code)}${weekStart ? `?weekStart=${weekStart}` : ""}`, { signal: controller.signal, cache: "no-store" })
      .then((value) => { if (!controller.signal.aborted) setRecipe(recipeSchema.parse(value)); })
      .catch((reason: unknown) => { if (!controller.signal.aborted) setError(reason instanceof Error ? reason.message : "Reçete alınamadı."); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [code, retry, weekStart]);
  return { recipe, error, loading, reload: () => setRetry((value) => value + 1) };
}
